import React, { useEffect, useMemo, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Card,
  Typography,
  CardContent,
  Divider,
  List,
  ListItemIcon,
  ListItemText,
  ListItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  useMediaQuery,
  Avatar,
  CardHeader,
} from "@mui/material";
import {
  useGetAllDhashboardFristQuery,
  useGetCustomerQuery,
  useGetMeetingQuery,
  useGetTeamQuery,
  useGetUserQuery,
  useGetAllDhashboardPolicyGroupByQuery,
  useGetProductBrandQuery,
  useGetConversationsDhashNotificationQuery,
  useGetAllBirthdayDhashboardQuery,
  useGetAllTypeOfCoveraegeDhashboardQuery,
  useGetClientTypeBarChartQuery,
} from "../../Api/attoDeskApi";
import {
  ICustomer,
  IMeeting,
  ITeam,
  IUserInfo,
  IPolicy,
  IProductBrand,
  IToDo,
  IInsuranceComapyPieChart,
} from "../../Api/Interface/api.interface";
import useDebounce from "../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../theme/appStyles";
import Pagination from "../../Components/Pagination";
import dayjs, { Dayjs } from "dayjs";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import InventoryIcon from "@mui/icons-material/Inventory";
import ShieldIcon from "@mui/icons-material/Shield";
import GroupIcon from "@mui/icons-material/Group";
import EventIcon from "@mui/icons-material/EventNote";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import { Link } from "react-router-dom";
import Badge from "@mui/material/Badge";
import CakeIcon from "@mui/icons-material/Cake";
import UpcomingIcon from "@mui/icons-material/Upcoming";
import InsuranceCompanyPieChart from "./Component/insuranceCompanyPieChart";
import CoverageTypePieChart from "./Component/coverageTypePieChart";
import ProductDetailsBarChart from "./Component/productDetailsBarChart";
import PolicyOwenerCilentType from "./Component/PolicyOwenerCilentType";

const capitalizeFirstLetter = (name: string | null | undefined) => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [paymentMonthYear, setPaymentMonthYear] = useState<Dayjs>(dayjs());
  const [selectedCilent, setSelectedClient] = useState<string | "">("");
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const { data: userData } = useGetUserQuery();

  const userId = React.useMemo(() => {
    if (userData?.data) {
      const userInfo = userData.data as IUserInfo;
      return userInfo.staffId;
    }
    return "";
  }, [userData]);

  const { data, isLoading, isError, refetch } = useGetMeetingQuery({
    searchText: currentSearchQuery,
    staffId: userId || "",
    clientId: selectedCilent,
    id: "",
    meeting_Date: paymentMonthYear.format("YYYY-MM-DD"),
  });

  const { data: staffData, isLoading: staffIsLoading } = useGetCustomerQuery({
    searchText: "",
    id: "",
  });

  const { data: teamData, isLoading: teamsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const { data: clientData, isLoading: clientIsLoading } =
    useGetAllDhashboardFristQuery({
      id: "",
    });

  const {
    data: policyData,
    isLoading: policyIsLoading,
    isError: policyIsError,
  } = useGetAllDhashboardPolicyGroupByQuery({
    searchText: "",
    id: "",
    policyCustomerId: "",
  });

  const { data: brandListData, isLoading: brandIsLoading } =
    useGetProductBrandQuery({
      searchText: "",
      isActive: true,
    });

  const {
    data: noificationData,
    isLoading: notificatinIsLoading,
    isError: notificationIsError,
  } = useGetConversationsDhashNotificationQuery({
    searchText: "",
    staffId: "",
    id: "",
  });

  const {
    data: birthdayData,
    isLoading: birthdayIsLoading,
    isError: birthdayIsError,
  } = useGetAllBirthdayDhashboardQuery({
    searchText: "",
    policyCustomerId: "",
    id: "",
  });

  const { data: coverageTypeOfData, isLoading: coverageTypeOfIsLoading } =
    useGetAllTypeOfCoveraegeDhashboardQuery({ id: "" });

  const { data: clientTypeData, isLoading: clientTypeIsLoading } =
    useGetClientTypeBarChartQuery({
      searchText: "",
      id: "",
      isPolicyOwnAndBenifiOnly: "policyOwner",
      customerClientId: "all",
    });

  const cliendUpList = useMemo(() => {
    return (staffData?.data ?? []) as ICustomer[];
  }, [staffData?.data]);

  const cliendList = useMemo(() => {
    return (teamData?.data ?? []) as ITeam[];
  }, [teamData?.data]);

  const brandList = useMemo(() => {
    return brandListData?.data as IProductBrand[];
  }, [brandListData?.data]);

  const todaysBirthdaysList = useMemo(() => {
    return birthdayData?.todaysBirthdays as ICustomer[];
  }, [birthdayData?.todaysBirthdays]);

  const upcomingBirthdaysList = useMemo(() => {
    return birthdayData?.upcomingBirthdays as ICustomer[];
  }, [birthdayData?.upcomingBirthdays]);

  const CoverageTypeOfData = useMemo(() => {
    return (coverageTypeOfData?.data as IInsuranceComapyPieChart[]) || [];
  }, [coverageTypeOfData?.data]);

  const clientTypeBarList = useMemo(() => {
    return (clientTypeData?.data ?? []) as ICustomer[];
  }, [clientTypeData?.data]);

  const clientMap = useMemo(() => {
    const map = new Map();
    cliendUpList?.forEach((category) => {
      map.set(
        category.id,
        capitalizeFirstLetter(category.customerFirstName || "") +
          " " +
          capitalizeFirstLetter(category.customerLastName || "")
      );
    });
    return map;
  }, [cliendUpList]);

  const staffMap = useMemo(() => {
    const map = new Map();
    cliendList?.forEach((category) => {
      map.set(
        category.id,
        capitalizeFirstLetter(category.teamFirstName || "") +
          " " +
          capitalizeFirstLetter(category.teamLastName || "")
      );
    });
    return map;
  }, [cliendList]);

  const brandMap = useMemo(() => {
    const map = new Map();
    brandList?.forEach((category) => {
      map.set(category.id, category.productBrandName);
    });
    return map;
  }, [brandList]);

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  if (
    isLoading ||
    staffIsLoading ||
    teamsLoading ||
    policyIsLoading ||
    clientIsLoading ||
    brandIsLoading ||
    birthdayIsLoading ||
    coverageTypeOfIsLoading ||
    clientTypeIsLoading ||
    notificatinIsLoading
  ) {
    return (
      <Box p={isMobile ? 2 : 1}>
        <Grid container spacing={2}>
          {[...Array(6)].map((_, index) => (
            <Grid
              item
              md={6}
              sm={6}
              xs={4}
              lg={2}
              key={`top-skeleton-${index}`}
            >
              <Skeleton
                variant="rectangular"
                // height={200}
                height={isMobile ? 50 : 100}
                animation="wave"
                className={classes.dhashboardCardSkeleton}
              />
            </Grid>
          ))}
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={3.5} md={12} sm={12} xs={12}>
                <Skeleton
                  variant="rectangular"
                  // height={200}
                  height={isMobile ? 100 : 300}
                  animation="wave"
                  className={classes.dhashboardCardSkeleton}
                />
              </Grid>
              <Grid item lg={5} md={12} sm={12} xs={12}>
                <Skeleton
                  variant="rectangular"
                  // height={200}
                  height={isMobile ? 100 : 300}
                  animation="wave"
                  className={classes.dhashboardCardSkeleton}
                />
              </Grid>
              <Grid item lg={3.5} md={12} sm={12} xs={12}>
                <Skeleton
                  variant="rectangular"
                  // height={200}
                  height={isMobile ? 100 : 300}
                  animation="wave"
                  className={classes.dhashboardCardSkeleton}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={3.5} md={12} sm={12} xs={12}>
                <Grid container spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Skeleton
                      variant="rectangular"
                      // height={200}
                      height={isMobile ? 300 : 400}
                      animation="wave"
                      className={classes.dhashboardCardSkeleton}
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Skeleton
                      variant="rectangular"
                      // height={200}
                      height={isMobile ? 200 : 300}
                      animation="wave"
                      className={classes.dhashboardCardSkeleton}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={8.5} md={12} sm={12} xs={12}>
                <Grid container spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Skeleton
                      variant="rectangular"
                      // height={200}
                      height={isMobile ? 300 : 200}
                      animation="wave"
                      className={classes.dhashboardCardSkeleton}
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Skeleton
                      variant="rectangular"
                      // height={200}
                      height={isMobile ? 200 : 500}
                      animation="wave"
                      className={classes.dhashboardCardSkeleton}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  }

  const coursings: IMeeting[] = Array.isArray(data?.data)
    ? (data?.data as IMeeting[])
    : [];

  const policies: IPolicy[] = Array.isArray(policyData?.data)
    ? (policyData?.data as IPolicy[])
    : [];

  const notificationList: IToDo[] = Array.isArray(noificationData?.data)
    ? (noificationData?.data as IToDo[])
    : [];

  return (
    <div>
      <Grid container>
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          sx={{
            // backgroundColor: "#d0ddd0",
            // background: `linear-gradient(to bottom, ${theme.palette.primary.main}, #fff)`,
            // background: `linear-gradient(to bottom,  ${theme.palette.cardAdd.thirdBgColor},${theme.palette.cardAdd.thirdBgColor},${theme.palette.cardAdd.thirdBgColor},${theme.palette.primary.main},  #fff)`,

            padding: isMobile ? 1 : 2,
            minHeight: "100vh",
            borderRadius: 3,
            // boxShadow: 3,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={2} md={4} sm={6} xs={6}>
                  <Card className={classes.staffDhashboardSmallCard}>
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        width="100%"
                        textAlign="center"
                      >
                        <Typography
                          className={classes.staffDhashboardSmallCardHeading}
                          fontWeight={600}
                          pt={1}
                        >
                          {clientData?.data.totalClients ?? "-"}
                        </Typography>
                        <Typography
                          className={classes.staffDhashboardSmallCardSubHeading}
                        >
                          Clients
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item lg={2} md={4} sm={6} xs={6}>
                  <Card className={classes.staffDhashboardSmallCard}>
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        width="100%"
                        textAlign="center"
                      >
                        <Typography
                          className={classes.staffDhashboardSmallCardHeading}
                          fontWeight={600}
                          pt={1}
                        >
                          {clientData?.data.totalPolicy ?? "-"}
                        </Typography>
                        <Typography
                          className={classes.staffDhashboardSmallCardSubHeading}
                        >
                          Policies
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item lg={2} md={4} sm={6} xs={6}>
                  <Card className={classes.staffDhashboardSmallCard}>
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        width="100%"
                        textAlign="center"
                      >
                        <Typography
                          className={classes.staffDhashboardSmallCardHeading}
                          fontWeight={600}
                          pt={1}
                        >
                          {clientData?.data.totalCoveragePolicy ?? "-"}
                        </Typography>
                        <Typography
                          className={classes.staffDhashboardSmallCardSubHeading}
                        >
                          Coverage
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item lg={2} md={4} sm={6} xs={6}>
                  <Card className={classes.staffDhashboardSmallCard}>
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        width="100%"
                        textAlign="center"
                      >
                        <Typography
                          className={classes.staffDhashboardSmallCardHeading}
                          fontWeight={600}
                          pt={1}
                        >
                          {clientData?.data.totalStaff ?? "-"}
                        </Typography>
                        <Typography
                          className={classes.staffDhashboardSmallCardSubHeading}
                        >
                          Staff
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item lg={2} md={4} sm={6} xs={6}>
                  <Card className={classes.staffDhashboardSmallCard}>
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        width="100%"
                        textAlign="center"
                      >
                        <Typography
                          className={classes.staffDhashboardSmallCardHeading}
                          fontWeight={600}
                          pt={1}
                        >
                          {clientData?.data.doneMeeting ?? "-"}
                        </Typography>
                        <Typography
                          className={classes.staffDhashboardSmallCardSubHeading}
                        >
                          Meeting
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item lg={2} md={4} sm={6} xs={6}>
                  <Card className={classes.staffDhashboardSmallCard}>
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        width="100%"
                        textAlign="center"
                      >
                        <Typography
                          className={classes.staffDhashboardSmallCardHeading}
                          fontWeight={600}
                          pt={1}
                        >
                          {clientData?.data.donetask ?? "-"}
                        </Typography>
                        <Typography
                          className={classes.staffDhashboardSmallCardSubHeading}
                        >
                          Task
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={3.5} md={12} sm={12} xs={12}>
                  <Card
                    className={classes.dhashboardCard}
                    sx={{ minHeight: 200 }}
                  >
                    <InsuranceCompanyPieChart />
                  </Card>
                </Grid>
                <Grid item lg={5} md={12} sm={12} xs={12}>
                  <Card
                    className={classes.dhashboardCard}
                    sx={{ minHeight: 200 }}
                  >
                    <ProductDetailsBarChart payrollData={CoverageTypeOfData} />
                  </Card>
                </Grid>
                <Grid item lg={3.5} md={12} sm={12} xs={12}>
                  <Card
                    className={classes.dhashboardCard}
                    sx={{ minHeight: 200 }}
                  >
                    <CoverageTypePieChart payrollData={CoverageTypeOfData} />
                  </Card>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={3.5} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    // spacing={2}
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card
                        className={classes.dhashboardCard}
                        sx={{ minHeight: 200 }}
                      >
                        <CardContent>
                          <Box display="flex" alignItems="center" mb={1}>
                            <Box
                              className={classes.dhashboardIcon}
                              sx={{ mr: 2 }}
                            >
                              <CakeIcon sx={{ color: "#616161" }} />
                            </Box>
                            <Typography className={classes.mL2Heading}>
                              Today's Birthday
                            </Typography>
                          </Box>
                          <Divider sx={{ my: 2, borderColor: "#bdbdbd" }} />

                          {birthdayIsError ? (
                            <Box textAlign="center" py={4}>
                              <Typography color="error">
                                Error fetching data
                              </Typography>
                            </Box>
                          ) : birthdayIsLoading ? (
                            <Box display="flex" justifyContent="center" py={4}>
                              <CircularProgress />
                            </Box>
                          ) : todaysBirthdaysList.length === 0 ? (
                            <Box textAlign="center" py={4}>
                              <Typography>No birthdays today</Typography>
                            </Box>
                          ) : (
                            <List sx={{ width: "100%" }}>
                              {todaysBirthdaysList.map((customer) => (
                                <Grid item xs={12} key={customer.id}>
                                  <Link
                                    to={`/profile/customer/${customer.id}`}
                                    className={classes.iconLinkPropNormal}
                                  >
                                    <Card
                                      onClick={() =>
                                        navigate(
                                          `/profile/customer/${customer.id}`
                                        )
                                      }
                                      elevation={0}
                                      sx={{
                                        background:
                                          theme.palette.cardAdd.bgColor,
                                        display: "flex",
                                        alignItems: "center",
                                        p: 1,
                                        py: 1,
                                        cursor: "pointer",
                                        transition: "background 0.2s",
                                        "&:hover": {
                                          backgroundColor:
                                            theme.palette.action.hover,
                                        },
                                      }}
                                    >
                                      <Badge
                                        color="primary"
                                        sx={{
                                          mr: 2,
                                          "& .MuiBadge-badge": {
                                            fontSize: "0.75rem",
                                            minWidth: 20,
                                            height: 20,
                                            borderRadius: "50%",
                                            backgroundColor: "green",
                                            color: "#fff",
                                          },
                                        }}
                                      >
                                        <Avatar
                                          sx={{ bgcolor: "primary.main" }}
                                        >
                                          {customer.customerFirstName ||
                                          customer.customerLastName ? (
                                            `${
                                              customer.customerFirstName ?? ""
                                            } ${
                                              customer.customerLastName ?? ""
                                            }`
                                              .trim()
                                              .charAt(0)
                                              .toUpperCase()
                                          ) : (
                                            <GroupIcon />
                                          )}
                                        </Avatar>
                                      </Badge>

                                      <Box>
                                        <Typography
                                          variant="subtitle1"
                                          fontWeight={600}
                                        >
                                          {customer.customerFirstName}{" "}
                                          {customer.customerLastName}
                                        </Typography>
                                      </Box>
                                    </Card>
                                  </Link>
                                </Grid>
                              ))}
                            </List>
                          )}
                        </CardContent>

                        <CardContent>
                          <Box display="flex" alignItems="center" mb={1}>
                            <Box
                              className={classes.dhashboardIcon}
                              sx={{ mr: 2 }}
                            >
                              <UpcomingIcon sx={{ color: "#616161" }} />
                            </Box>
                            <Typography className={classes.mL2Heading}>
                              Upcoming Birthdays
                            </Typography>
                          </Box>
                          <Divider sx={{ my: 2, borderColor: "#bdbdbd" }} />

                          {birthdayIsError ? (
                            <Box textAlign="center" py={4}>
                              <Typography color="error">
                                Error fetching data
                              </Typography>
                            </Box>
                          ) : birthdayIsLoading ? (
                            <Box display="flex" justifyContent="center" py={4}>
                              <CircularProgress />
                            </Box>
                          ) : upcomingBirthdaysList.length === 0 ? (
                            <Box textAlign="center" py={4}>
                              <Typography>No upcoming birthdays</Typography>
                            </Box>
                          ) : (
                            <List sx={{ width: "100%" }}>
                              {upcomingBirthdaysList.map((customer) => (
                                <Grid item xs={12} key={customer.id}>
                                  <Link
                                    to={`/profile/customer/${customer.id}`}
                                    className={classes.iconLinkPropNormal}
                                  >
                                    <Card
                                      onClick={() =>
                                        navigate(
                                          `/profile/customer/${customer.id}`
                                        )
                                      }
                                      elevation={0}
                                      sx={{
                                        background:
                                          theme.palette.cardAdd.bgColor,
                                        display: "flex",
                                        alignItems: "center",
                                        p: 1,
                                        py: 1,
                                        borderRadius: 2,
                                        cursor: "pointer",
                                        transition: "background 0.2s",
                                        "&:hover": {
                                          backgroundColor:
                                            theme.palette.action.hover,
                                        },
                                      }}
                                    >
                                      <Badge
                                        color="primary"
                                        sx={{
                                          mr: 2,
                                          "& .MuiBadge-badge": {
                                            fontSize: "0.75rem",
                                            minWidth: 20,
                                            height: 20,
                                            borderRadius: "50%",
                                            backgroundColor: "green",
                                            color: "#fff",
                                          },
                                        }}
                                      >
                                        <Avatar
                                          sx={{ bgcolor: "primary.main" }}
                                        >
                                          {customer.customerFirstName ||
                                          customer.customerLastName ? (
                                            `${
                                              customer.customerFirstName ?? ""
                                            } ${
                                              customer.customerLastName ?? ""
                                            }`
                                              .trim()
                                              .charAt(0)
                                              .toUpperCase()
                                          ) : (
                                            <GroupIcon />
                                          )}
                                        </Avatar>
                                      </Badge>

                                      <Box>
                                        <Typography
                                          variant="subtitle1"
                                          fontWeight={600}
                                        >
                                          {customer.customerFirstName}{" "}
                                          {customer.customerLastName}
                                        </Typography>
                                        <Typography
                                          variant="body2"
                                          color="text.secondary"
                                        >
                                          {customer.customerDateOfBirth
                                            ? new Date(
                                                customer.customerDateOfBirth
                                              ).toLocaleDateString()
                                            : "No DOB"}
                                        </Typography>
                                      </Box>
                                    </Card>
                                  </Link>
                                </Grid>
                              ))}
                            </List>
                          )}
                        </CardContent>
                      </Card>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12} mt={2}>
                      <Card
                        className={classes.dhashboardCard}
                        sx={{ minHeight: 200 }}
                      >
                        <CardContent>
                          <Box display="flex" alignItems="center" mb={1}>
                            <Box
                              className={classes.dhashboardIcon}
                              sx={{
                                mr: 2,
                              }}
                            >
                              <EventIcon sx={{ color: "#616161" }} />{" "}
                              {/* Dark grey icon */}
                            </Box>
                            <Typography className={classes.mL2Heading}>
                              Today’s Meetings
                            </Typography>
                          </Box>
                          <Divider sx={{ my: 2, borderColor: "#bdbdbd" }} />{" "}
                          {/* Light grey divider */}
                          {isError ? (
                            <Box textAlign="center" py={4}>
                              <Typography color="error">
                                Error fetching data
                              </Typography>
                            </Box>
                          ) : isLoading ? (
                            <Box display="flex" justifyContent="center" py={4}>
                              <CircularProgress />
                            </Box>
                          ) : (
                            <>
                              {coursings.length === 0 ? (
                                <Box textAlign="center" py={4}>
                                  <Typography>
                                    No meetings scheduled today
                                  </Typography>
                                </Box>
                              ) : (
                                <List sx={{ width: "100%" }}>
                                  {coursings.map((row, index) => (
                                    <Grid item xs={12} key={row.id}>
                                      <Link
                                        to={`/meeting/profile/${row.id}`}
                                        className={classes.iconLinkPropNormal}
                                      >
                                        <Card
                                          onClick={() => {
                                            navigate(
                                              `/meeting/profile/${row.id}`
                                            );
                                          }}
                                          elevation={0}
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            p: 2,
                                            borderRadius: 2,
                                            cursor: "pointer",
                                            backgroundColor:
                                              theme.palette.cardAdd.bgColor,
                                            transition: "background 0.2s",
                                            "&:hover": {
                                              backgroundColor:
                                                theme.palette.action.hover,
                                            },
                                          }}
                                        >
                                          <Avatar
                                            sx={{
                                              bgcolor:
                                                row?.meeting_category_color ||
                                                "primary.main",
                                            }}
                                          >
                                            {row?.subject
                                              ?.charAt(0)
                                              .toUpperCase() || <GroupIcon />}
                                          </Avatar>
                                          <Grid
                                            container
                                            direction="column"
                                            pl={1}
                                          >
                                            <Typography
                                              // variant="subtitle1"
                                              fontWeight={600}
                                              noWrap
                                            >
                                              {row.subject || ""}
                                            </Typography>
                                            {(row?.clientId ||
                                              row?.clientId ||
                                              row?.meeting_Date ||
                                              row?.meeting_time) && (
                                              <Typography
                                                color="text.secondary"
                                                sx={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 1,
                                                  flexWrap: "wrap",
                                                }}
                                              >
                                                {[
                                                  row?.clientId
                                                    ? clientMap.get(
                                                        Number(row.clientId)
                                                      )
                                                    : null,
                                                  row?.staffId
                                                    ? staffMap.get(
                                                        Number(row.staffId)
                                                      )
                                                    : null,
                                                  row?.meeting_Date
                                                    ? ` ${dayjs(
                                                        row.meeting_Date
                                                      ).format("MMM D, YYYY")}`
                                                    : null,
                                                  row?.meeting_time
                                                    ? ` ${formatTime(
                                                        row.meeting_time
                                                      )}`
                                                    : null,
                                                ]
                                                  .filter(Boolean)
                                                  .map((text, idx, arr) => (
                                                    <span key={idx}>
                                                      {text}
                                                      {idx < arr.length - 1 &&
                                                        " | "}
                                                    </span>
                                                  ))}
                                              </Typography>
                                            )}
                                          </Grid>
                                        </Card>
                                      </Link>
                                    </Grid>
                                  ))}
                                </List>
                              )}
                            </>
                          )}
                        </CardContent>

                        <CardContent>
                          <Box display="flex" alignItems="center" mb={1}>
                            <Box
                              className={classes.dhashboardIcon}
                              sx={{
                                mr: 2,
                              }}
                            >
                              <EventIcon sx={{ color: "#616161" }} />{" "}
                              {/* Dark grey icon */}
                            </Box>
                            <Typography className={classes.mL2Heading}>
                              Today’s Todo
                            </Typography>
                          </Box>
                          <Divider sx={{ my: 2, borderColor: "#bdbdbd" }} />{" "}
                          {/* Light grey divider */}
                          {notificationIsError ? (
                            <Box textAlign="center" py={4}>
                              <Typography color="error">
                                Error fetching data
                              </Typography>
                            </Box>
                          ) : notificatinIsLoading ? (
                            <Box display="flex" justifyContent="center" py={4}>
                              <CircularProgress />
                            </Box>
                          ) : (
                            <>
                              {notificationList.length === 0 ? (
                                <Box textAlign="center" py={4}>
                                  <Typography>No Todo Active today</Typography>
                                </Box>
                              ) : (
                                <List sx={{ width: "100%" }}>
                                  {notificationList.map((group, index) => (
                                    <Grid item xs={12} key={group.id}>
                                      <Link
                                        to={`/conversations/messages/${group.id}`}
                                        className={classes.iconLinkPropNormal}
                                      >
                                        <Card
                                          onClick={() => {
                                            navigate(
                                              `/conversations/messages/${group.id}`
                                            );
                                          }}
                                          elevation={0}
                                          sx={{
                                            backgroundColor:
                                              theme.palette.cardAdd.bgColor,
                                            display: "flex",
                                            alignItems: "center",
                                            p: 2,
                                            borderRadius: 2,
                                            cursor: "pointer",
                                            transition: "background 0.2s",
                                            "&:hover": {
                                              backgroundColor:
                                                theme.palette.action.hover,
                                            },
                                          }}
                                        >
                                          <Badge
                                            badgeContent={
                                              group.unread_count > 0
                                                ? group.unread_count
                                                : null
                                            }
                                            color="primary"
                                            sx={{
                                              mr: 2,
                                              "& .MuiBadge-badge": {
                                                fontSize: "0.75rem",
                                                minWidth: 20,
                                                height: 20,
                                                borderRadius: "50%",
                                                backgroundColor: "green",
                                                color: "#fff",
                                              },
                                            }}
                                          >
                                            <Avatar
                                              sx={{ bgcolor: "primary.main" }}
                                            >
                                              {group.subject ? (
                                                group.subject
                                                  .charAt(0)
                                                  .toUpperCase()
                                              ) : (
                                                <GroupIcon />
                                              )}
                                            </Avatar>
                                          </Badge>

                                          <Grid container direction="column">
                                            <Typography
                                              variant="subtitle1"
                                              fontWeight={600}
                                              noWrap
                                            >
                                              {group.subject || "Unnamed Group"}
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              color={
                                                group.unread_count > 0
                                                  ? "green"
                                                  : "text.secondary"
                                              }
                                              fontWeight={
                                                group.unread_count > 0
                                                  ? 600
                                                  : 400
                                              }
                                            >
                                              {group.unread_count > 0
                                                ? `You have ${
                                                    group.unread_count
                                                  } unread ${
                                                    group.unread_count === 1
                                                      ? "message"
                                                      : "messages"
                                                  }`
                                                : "No new messages"}
                                            </Typography>
                                          </Grid>
                                        </Card>
                                      </Link>
                                    </Grid>
                                  ))}
                                </List>
                              )}
                            </>
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={8.5} md={12} sm={12} xs={12}>
                  <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card
                        className={classes.dhashboardCard}
                        sx={{ minHeight: 200 }}
                      >
                        <PolicyOwenerCilentType
                          payrollData={clientTypeBarList}
                        />
                      </Card>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.dhashboardCard}>
                        <CardContent>
                          <Box display="flex" alignItems="center" mb={2}>
                            <Box
                              sx={{
                                background: "#cdcdcd",
                                borderRadius: "50%",
                                width: 50,
                                height: 50,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mr: 2,
                              }}
                            >
                              <ShieldIcon sx={{ color: "#3b4045" }} />{" "}
                              {/* Grey icon */}
                            </Box>
                            <Typography className={classes.mL2Heading}>
                              Recently Updated Policies
                            </Typography>
                          </Box>

                          <Grid container>
                            <TableContainer>
                              <Table className={classes.table}>
                                <TableHead className={classes.tableHeaderRow}>
                                  <TableRow>
                                    <TableCell className={classes.tablheader}>
                                      <strong>Policy Number</strong>
                                    </TableCell>
                                    <TableCell
                                      className={classes.tablheader}
                                      sx={{ textAlign: "center" }}
                                    >
                                      <strong>Owner</strong>
                                    </TableCell>
                                    <TableCell
                                      className={classes.tablheader}
                                      sx={{ textAlign: "center" }}
                                    >
                                      <strong>Company</strong>
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {policyIsError || policies.length === 0 ? (
                                    <TableRow>
                                      <TableCell colSpan={20} align="center">
                                        {isError
                                          ? "Error fetching data"
                                          : "No data available"}
                                      </TableCell>
                                    </TableRow>
                                  ) : (
                                    policies
                                      .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                      )
                                      .map((policy: IPolicy, index) => (
                                        <TableRow
                                          key={policy.id}
                                          className={classes.tableRowHover}
                                        >
                                          <TableCell
                                            scope="row"
                                            className={classes.tablCell}
                                          >
                                            <Link
                                              to={`/customer/${policy.policyCustomerId}/policy/${policy.policyNumber}`}
                                              className={
                                                classes.iconLinkPropNormal
                                              }
                                            >
                                              <Typography
                                                sx={{
                                                  color: "#1976d2", // Link color
                                                  cursor: "pointer",
                                                  display: "inline-flex",
                                                  gap: 1,
                                                }}
                                                // onClick={() =>
                                                //   navigate(
                                                //     `/customer/${policy.policyCustomerId}/policy/${policy.policyNumber}`
                                                //   )
                                                // }
                                              >
                                                {policy.policyNumber}
                                                <FontAwesomeIcon
                                                  icon={faLink}
                                                />
                                              </Typography>
                                            </Link>
                                          </TableCell>
                                          <TableCell
                                            scope="row"
                                            className={classes.tablCell}
                                            sx={{ textAlign: "center" }}
                                          >
                                            <Link
                                              to={`/profile/customer/${policy.policyCustomerId}`}
                                              className={
                                                classes.iconLinkPropNormal
                                              }
                                            >
                                              <Typography
                                                sx={{
                                                  color: "#1976d2",
                                                  cursor: "pointer",
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  gap: 1,
                                                }}
                                                onClick={() =>
                                                  navigate(
                                                    `/profile/customer/${policy.policyCustomerId}`
                                                  )
                                                }
                                              >
                                                {clientMap.get(
                                                  Number(
                                                    policy.policyCustomerId
                                                  )
                                                ) || ""}
                                                <FontAwesomeIcon
                                                  icon={faUser}
                                                />
                                              </Typography>
                                            </Link>
                                          </TableCell>
                                          <TableCell
                                            scope="row"
                                            className={classes.tablCell}
                                            sx={{ textAlign: "center" }}
                                          >
                                            <Typography>
                                              {brandMap.get(
                                                Number(
                                                  policy.policyInsuranceCompanyId
                                                )
                                              ) || "-"}
                                            </Typography>
                                          </TableCell>
                                        </TableRow>
                                      ))
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
